import './Footer.css'
import React from 'react'

export default props =>
<footer className="footer">
    <p>Desenvolvido pela CI Sistemas de Informática Ltda</p>
</footer>